import { render, staticRenderFns } from "./contactTabDetails.vue?vue&type=template&id=76b615ca"
import script from "./contactTabDetails.vue?vue&type=script&lang=js"
export * from "./contactTabDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports